import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import CloseIcon from '@mui/icons-material/Close';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import {
  Backdrop,
  Box,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  CircularProgress,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import DatePicker from '@mui/lab/DatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterMoment from '@mui/lab/AdapterMoment';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { makeStyles } from '@mui/styles';
import moment from 'moment';
import React from 'react';
import NumberFormat from 'react-number-format';
import { useDispatch, useSelector } from 'react-redux';
import { generalFollowActions } from 'src/store/slices/generalFollowSlice';
import axios from 'src/utils/axios';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  tableCell: {
    fontWeight: '600',
    fontSize: '14px',
    color: 'black',
    whiteSpace: 'nowrap'
  },
  tableCellBilgi: {
    fontSize: '14px',
    color: 'black',
    whiteSpace: 'nowrap'
  }
}));
const NumberFormatCustom = React.forwardRef(
  function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value
            }
          });
        }}
        thousandSeparator="."
        decimalSeparator=","
        decimalScale={2}
        allowNegative={false}
        isNumericString
        suffix="₺"
      />
    );
  }
);
function InvoiceRefund() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const invoiceData = useSelector(
    (state) => state.generalFollowSlice.invoiceDetail
  );

  const offerProductPrice = useSelector(
    (state) => state.generalFollowSlice.updatedOfferPrice
  );
  const topModelDifferentPrice = useSelector(
    (state) => state.generalFollowSlice.updatedTopModelDifferentPrice
  );

  const subModelDifferenceAmount = useSelector(
    (state) => state.generalFollowSlice.updatedSubModelDifferenceAmount
  );

  const [receiptNumber, setReceiptNumber] = React.useState(
    invoiceData[0]?.Consumer?.ChangeInvoiceNo
  );
  const [receiptDate, setReceiptDate] = React.useState(
    moment(invoiceData[0]?.Consumer?.ChangeInvoiceDate).format('DD.MM.YYYY')
  );
  const [invoiceAmount, setInvoiceAmount] = React.useState(
    invoiceData[0]?.Consumer?.ChangeInvoiceAmount
      ? invoiceData[0]?.Consumer?.ChangeInvoiceAmount.toString().replace(
          '.',
          ','
        )
      : 0
  );
  const [invoiceItemQuantity, setInvoiceItemQuantity] = React.useState(
    invoiceData[0]?.Consumer?.ChangeInvoiceItemQuantity
  );
  const [retailerProductPriceData, setRetailerProductPriceData] =
    React.useState([]);
  const [retailerProductPricePopUp, setRetailerProductPricePopUp] =
    React.useState(false);
  const [productPriceData, setProductPriceData] = React.useState([]);
  const [productPricePopUp, setProductPricePopUp] = React.useState(false);
  const [wholesalePricePopUp, setWholesalePricePopUp] = React.useState(false);
  const [wholesalePriceData, setWholesalePriceData] = React.useState([]);
  const [searchModelCode, setSearchModelCode] = React.useState('');
  const [selectedDate, setSelectedDate] = React.useState(moment());
  const [collapsed, setCollapsed] = React.useState(false);

  const handleToggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const totalProductPrice =
    parseFloat(topModelDifferentPrice) + parseFloat(offerProductPrice);

  const [loading, setLoading] = React.useState(false);

  function changeInvoiceNo(val) {
    //Fatura No
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].Consumer.ChangeInvoiceNo = val;
    dispatch(generalFollowActions.updateNewData(tempData));
    setReceiptNumber(val);
  }

  function changeInvoiceDate(val) {
    //Fatura Tarihi
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].Consumer.ChangeInvoiceDate = val;
    dispatch(generalFollowActions.updateNewData(tempData));
    setReceiptDate(val);
  }

  function changeInvoiceAmount(val) {
    //Fatura Tutarı
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    if (
      invoiceData[0]?.Consumer?.UpTypeId === 6 &&
      (invoiceData[0]?.Consumer?.ConsumerType === 2 ||
        invoiceData[0]?.Consumer?.ConsumerType === 3)
    ) {
      tempData[0].Exchange.ReceivedProductPrice = val;
      let value =
        parseFloat(val) +
        totalProductPrice -
        parseFloat(subModelDifferenceAmount);
      tempData[0].Exchange.GiveProductPrice = value < 0 ? 0 : value;
      dispatch(
        generalFollowActions.updateGiveProductPrice(
          tempData[0].Exchange.GiveProductPrice
        )
      );
      dispatch(
        generalFollowActions.updateReceivedProductPrice(
          tempData[0].Exchange.ReceivedProductPrice
        )
      );
      dispatch(generalFollowActions.updateInvoiceChanged(true));
    }

    tempData[0].Consumer.ChangeInvoiceAmount = val;
    dispatch(generalFollowActions.updateNewData(tempData));
    setInvoiceAmount(val);
  }

  function changeInvoiceItemQuantity(val) {
    //Toplam ürün adet
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].Consumer.ChangeInvoiceItemQuantity = val;
    dispatch(generalFollowActions.updateNewData(tempData));
    setInvoiceItemQuantity(val);
  }

  function GetRetailerProductSellPrice() {
    setLoading(true);
    const data = [
      invoiceData[0]?.Retailer?.UserCode?.toString(),
      invoiceData[0]?.Model?.UserModelCode.toString()
    ];
    axios
      .get(`/ProductSellPrice/${data[0]}/${data[1]}`, {})
      .then((response) => {
        if (response?.data?.length > 0) {
          setRetailerProductPriceData(response.data);
          setRetailerProductPricePopUp(true);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  function GetProductSellPrice() {
    setLoading(true);
    axios
      .get(
        `/ProductSellPrice/${0}/${invoiceData[0]?.Model?.UserModelCode.toString()}`,
        {}
      )
      .then((response) => {
        if (response?.data?.length > 0) {
          setProductPriceData(response.data);
          setProductPricePopUp(true);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  function GetWholesalePrice() {
    const kulModelKodu = invoiceData[0]?.Model?.UserModelCode || '';
    const currentDate = moment();
    setSearchModelCode(kulModelKodu);
    setWholesalePriceData([]);
    setSelectedDate(currentDate);
    setWholesalePricePopUp(true);

    // Otomatik olarak API'ye istek at
    if (kulModelKodu) {
      setLoading(true);
      axios
        .post(
          `/GetDiaToptanFiyat/${kulModelKodu}/${currentDate.format('YYYYMMDD')}`
        )
        .then((response) => {
          const data =
            typeof response.data === 'string'
              ? JSON.parse(response.data)
              : response.data;
          setWholesalePriceData(data?.ET_DATA || []);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
      console.log('Seçilen Tarih:', currentDate.format('YYYYMMDD'));
      console.log('Model Kodu:', kulModelKodu);
    }
  }

  function SearchWholesalePrice() {
    if (!searchModelCode) {
      return;
    }
    setLoading(true);
    axios
      .post(
        `/GetDiaToptanFiyat/${searchModelCode}/${selectedDate.format('YYYYMMDD')}`
      )
      .then((response) => {
        const data =
          typeof response.data === 'string'
            ? JSON.parse(response.data)
            : response.data;
        setWholesalePriceData(data?.ET_DATA || []);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  return (
    <Grid style={{ paddingTop: 5 }}>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card
        sx={{
          border: '1px solid #e0e0e0',
          borderRadius: '12px',
          position: 'sticky',
          top: 210,
          zIndex: 7,
          backgroundColor: '#f5f5f5',
          boxShadow: 'none'
        }}
      >
        <CardHeader
          sx={{
            backgroundColor: '#f5f5f5',
            borderRadius: '12px',
            padding: '12px 16px',
            '& .MuiCardHeader-title': {
              fontSize: '12px',
              fontWeight: 500
            }
          }}
          avatar={
            <DragIndicatorIcon sx={{ color: '#FF9800', fontSize: '20px' }} />
          }
          action={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Tooltip title="Bayi-Ürün Bazlı Satış Fiyat" placement="top">
                <IconButton
                  onClick={() => GetRetailerProductSellPrice()}
                  sx={{
                    color: '#FF9800',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 152, 0, 0.08)',
                      transform: 'scale(1.1)'
                    },
                    transition: 'all 0.2s',
                    padding: '6px'
                  }}
                >
                  <EqualizerIcon sx={{ fontSize: '20px' }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Ürün Bazlı Satış Fiyat" placement="top">
                <IconButton
                  onClick={() => GetProductSellPrice()}
                  sx={{
                    color: '#FF9800',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 152, 0, 0.08)',
                      transform: 'scale(1.1)'
                    },
                    transition: 'all 0.2s',
                    padding: '6px'
                  }}
                >
                  <AutoGraphIcon sx={{ fontSize: '20px' }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Toptan Satış Fiyatı" placement="top">
                <IconButton
                  onClick={() => GetWholesalePrice()}
                  sx={{
                    color: '#FF9800',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 152, 0, 0.08)',
                      transform: 'scale(1.1)'
                    },
                    transition: 'all 0.2s',
                    padding: '6px'
                  }}
                >
                  <ShoppingCartIcon sx={{ fontSize: '20px' }} />
                </IconButton>
              </Tooltip>
              <Tooltip title={collapsed ? 'Genişlet' : 'Daralt'}>
                <IconButton
                  onClick={handleToggleCollapse}
                  sx={{ color: '#FF9800' }}
                >
                  {collapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                </IconButton>
              </Tooltip>
            </Box>
          }
          title="İade Fatura Alanı"
        />
        <Collapse in={!collapsed} timeout="auto" unmountOnExit>
          <CardContent
            sx={{
              padding: '16px',
              backgroundColor: '#fff',
              borderRadius: '0 0 12px 12px'
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  id="input-with-icon-textfield"
                  label="Fatura No"
                  value={receiptNumber}
                  onChange={(event) => {
                    changeInvoiceNo(event.target.value);
                  }}
                  size="small"
                  fullWidth
                  variant="outlined"
                  inputProps={{
                    style: { fontSize: '12px' }
                  }}
                  InputLabelProps={{
                    style: { fontSize: '11px', color: '#757575' }
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="input-with-icon-textfield"
                  label="Fatura Tarihi"
                  value={receiptDate}
                  onChange={(event) => {
                    changeInvoiceDate(event.target.value);
                  }}
                  size="small"
                  fullWidth
                  variant="outlined"
                  inputProps={{
                    style: { fontSize: '12px' }
                  }}
                  InputLabelProps={{
                    style: { fontSize: '11px', color: '#757575' }
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Fatura Tutarı"
                  name="numberformat"
                  id="formatted-numberformat-input"
                  size="small"
                  value={invoiceAmount}
                  onChange={(event) => {
                    changeInvoiceAmount(event.target.value);
                  }}
                  fullWidth
                  InputProps={{
                    inputComponent: NumberFormatCustom,
                    style: { fontSize: '12px' }
                  }}
                  InputLabelProps={{
                    style: { fontSize: '11px', color: '#757575' }
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="input-with-icon-textfield"
                  label="Toplam Ürün Adet"
                  size="small"
                  value={invoiceItemQuantity}
                  onChange={(event) => {
                    changeInvoiceItemQuantity(event.target.value);
                  }}
                  fullWidth
                  variant="outlined"
                  inputProps={{
                    style: { fontSize: '12px' }
                  }}
                  InputLabelProps={{
                    style: { fontSize: '11px', color: '#757575' }
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Collapse>
      </Card>

      {/*Bayi Ürün Bazlı Satış Detay popup */}

      <Dialog
        open={retailerProductPricePopUp}
        onClose={() => setRetailerProductPricePopUp(false)}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="xl"
      >
        <DialogTitle
          sx={{
            width: '100%',
            color: 'red',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
        >
          {'Bayi-Ürün Bazlı Satış Fiyat'}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <TableContainer>
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow sx={{ width: '100%' }}>
                      <TableCell className={classes.tableCell} align="center">
                        Bayi Kodu
                      </TableCell>
                      <TableCell className={classes.tableCell} align="center">
                        Bayi
                      </TableCell>
                      <TableCell className={classes.tableCell} align="center">
                        Fatura Tarihi
                      </TableCell>
                      <TableCell className={classes.tableCell} align="center">
                        Fatura No
                      </TableCell>
                      <TableCell className={classes.tableCell} align="center">
                        Fatura Satır
                      </TableCell>
                      <TableCell className={classes.tableCell} align="center">
                        Koşul Kodu
                      </TableCell>
                      <TableCell className={classes.tableCell} align="center">
                        Koşul
                      </TableCell>
                      <TableCell className={classes.tableCell} align="center">
                        Vergili Fiyat
                      </TableCell>
                      <TableCell className={classes.tableCell} align="center">
                        Vergisiz Fiyat
                      </TableCell>
                      <TableCell className={classes.tableCell} align="center">
                        Ortalama Vade
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {retailerProductPriceData?.map((row) => (
                      <TableRow
                        key={row.DealerCode}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 }
                        }}
                      >
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="center"
                        >
                          {row.DealerCode}
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="left"
                        >
                          {row.DealerDescription}
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="center"
                        >
                          {row.InvoiceDate}
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="left"
                        >
                          {row.InvoiceNr}
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="center"
                        >
                          {row.InvoiceRow}
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="center"
                        >
                          {row.ConditionNr}
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="center"
                        >
                          {row.ConditionDescription}
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="left"
                        >
                          {row.TaxPrice}
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="center"
                        >
                          {row.NoTaxPrice}
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="center"
                        >
                          {row.AvgPrice}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <IconButton
            sx={{ color: '#424242' }}
            onClick={() => setRetailerProductPricePopUp(false)}
            aria-label="close"
            component="span"
            variant="contained"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>

      {/*Ürün Bazlı Satış Detay popup */}

      <Dialog
        open={productPricePopUp}
        onClose={() => setProductPricePopUp(false)}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="xl"
      >
        <DialogTitle
          sx={{
            width: '100%',
            color: 'red',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
        >
          {'Ürün Bazlı Satış Fiyat'}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <TableContainer>
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow sx={{ width: '100%' }}>
                      <TableCell className={classes.tableCell} align="center">
                        Bayi Kodu
                      </TableCell>
                      <TableCell className={classes.tableCell} align="center">
                        Bayi
                      </TableCell>
                      <TableCell className={classes.tableCell} align="center">
                        Fatura Tarihi
                      </TableCell>
                      <TableCell className={classes.tableCell} align="center">
                        Fatura No
                      </TableCell>
                      <TableCell className={classes.tableCell} align="center">
                        Fatura Satır
                      </TableCell>
                      <TableCell className={classes.tableCell} align="center">
                        Koşul Kodu
                      </TableCell>
                      <TableCell className={classes.tableCell} align="center">
                        Koşul
                      </TableCell>
                      <TableCell className={classes.tableCell} align="center">
                        Vergili Fiyat
                      </TableCell>
                      <TableCell className={classes.tableCell} align="center">
                        Vergisiz Fiyat
                      </TableCell>
                      <TableCell className={classes.tableCell} align="center">
                        Ortalama Vade
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {productPriceData?.map((row) => (
                      <TableRow
                        key={row.DealerCode}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 }
                        }}
                      >
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="center"
                        >
                          {row.DealerCode}
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="left"
                        >
                          {row.DealerDescription}
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="center"
                        >
                          {row.InvoiceDate}
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="left"
                        >
                          {row.InvoiceNr}
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="center"
                        >
                          {row.InvoiceRow}
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="center"
                        >
                          {row.ConditionNr}
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="center"
                        >
                          {row.ConditionDescription}
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="left"
                        >
                          {row.TaxPrice}
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="center"
                        >
                          {row.NoTaxPrice}
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBilgi}
                          align="center"
                        >
                          {row.AvgPrice}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <IconButton
            sx={{ color: '#424242' }}
            onClick={() => setProductPricePopUp(false)}
            aria-label="close"
            component="span"
            variant="contained"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>

      {/*Toptan Satış Fiyatı popup */}

      <Dialog
        open={wholesalePricePopUp}
        onClose={() => setWholesalePricePopUp(false)}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="xl"
        PaperProps={{
          sx: {
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
          }
        }}
      >
        <DialogTitle
          sx={{
            width: '100%',
            color: '#FF9800',
            fontSize: '16px',
            fontWeight: 600,
            borderBottom: '2px solid #f5f5f5',
            pb: 2
          }}
        >
          {'Toptan Satış Fiyatı'}
        </DialogTitle>
        <DialogContent sx={{ pt: 3, pb: 2, px: 3 }}>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
                <TextField
                  label="Model Kodu"
                  value={searchModelCode}
                  onChange={(event) => setSearchModelCode(event.target.value)}
                  size="small"
                  fullWidth
                  variant="outlined"
                  InputProps={{
                    style: { fontSize: '13px', borderRadius: '10px' }
                  }}
                  inputProps={{
                    style: { fontSize: '13px' }
                  }}
                  InputLabelProps={{
                    style: { fontSize: '12px', color: '#757575' }
                  }}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      SearchWholesalePrice();
                    }
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '10px',
                      '&:hover fieldset': {
                        borderColor: '#FF9800'
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#FF9800'
                      }
                    }
                  }}
                />
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label="Tarih"
                    value={selectedDate}
                    onChange={(newValue) => setSelectedDate(newValue)}
                    inputFormat="DD.MM.YYYY"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                          style: { fontSize: '13px', borderRadius: '10px' }
                        }}
                        inputProps={{
                          ...params.inputProps,
                          style: { fontSize: '13px' }
                        }}
                        InputLabelProps={{
                          style: { fontSize: '12px', color: '#757575' }
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                            '&:hover fieldset': {
                              borderColor: '#FF9800'
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#FF9800'
                            }
                          }
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
                <Tooltip title="Ara" placement="top">
                  <IconButton
                    onClick={() => SearchWholesalePrice()}
                    sx={{
                      color: '#fff',
                      backgroundColor: '#FF9800',
                      borderRadius: '10px',
                      padding: '8px 12px',
                      '&:hover': {
                        backgroundColor: '#F57C00',
                        transform: 'scale(1.05)'
                      },
                      transition: 'all 0.2s',
                      boxShadow: '0 2px 8px rgba(255, 152, 0, 0.3)'
                    }}
                  >
                    <SearchIcon sx={{ fontSize: '20px' }} />
                  </IconButton>
                </Tooltip>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <TableContainer
                sx={{
                  maxHeight: 400,
                  borderRadius: '12px',
                  border: '1px solid #e0e0e0',
                  '&::-webkit-scrollbar': {
                    width: '8px'
                  },
                  '&::-webkit-scrollbar-track': {
                    background: '#f1f1f1',
                    borderRadius: '10px'
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#FF9800',
                    borderRadius: '10px'
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: '#F57C00'
                  }
                }}
              >
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow sx={{ width: '100%' }}>
                      <TableCell
                        className={classes.tableCell}
                        align="left"
                        sx={{ backgroundColor: '#f9f9f9', fontWeight: 600 }}
                      >
                        Açıklama
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        align="center"
                        sx={{ backgroundColor: '#f9f9f9', fontWeight: 600 }}
                      >
                        Fiyat Başlangıç Geçerlilik Tarihi
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        align="center"
                        sx={{ backgroundColor: '#f9f9f9', fontWeight: 600 }}
                      >
                        Fiyat Son Geçerlilik Tarihi
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        align="right"
                        sx={{ backgroundColor: '#f9f9f9', fontWeight: 600 }}
                      >
                        KDV'li Peşin Fiyat
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        align="right"
                        sx={{ backgroundColor: '#f9f9f9', fontWeight: 600 }}
                      >
                        30 Gün Vadeli
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        align="right"
                        sx={{ backgroundColor: '#f9f9f9', fontWeight: 600 }}
                      >
                        60 Gün Vadeli
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        align="right"
                        sx={{ backgroundColor: '#f9f9f9', fontWeight: 600 }}
                      >
                        90 Gün Vadeli
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        align="right"
                        sx={{ backgroundColor: '#f9f9f9', fontWeight: 600 }}
                      >
                        120 Gün Vadeli
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {wholesalePriceData?.length > 0 ? (
                      wholesalePriceData.map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 },
                            '&:hover': {
                              backgroundColor: '#fff8f0',
                              cursor: 'pointer'
                            },
                            transition: 'all 0.2s'
                          }}
                        >
                          <TableCell
                            className={classes.tableCellBilgi}
                            align="left"
                          >
                            {row.MAKTX || '-'}
                          </TableCell>
                          <TableCell
                            className={classes.tableCellBilgi}
                            align="center"
                          >
                            {row.DATAB
                              ? moment(row.DATAB).format('DD.MM.YYYY')
                              : '-'}
                          </TableCell>
                          <TableCell
                            className={classes.tableCellBilgi}
                            align="center"
                          >
                            {row.DATBI
                              ? moment(row.DATBI).format('DD.MM.YYYY')
                              : '-'}
                          </TableCell>
                          <TableCell
                            className={classes.tableCellBilgi}
                            align="right"
                            sx={{ fontWeight: 600, color: '#FF9800' }}
                          >
                            {row.KBETR
                              ? `${parseFloat(row.KBETR).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TL`
                              : '0,00 TL'}
                          </TableCell>
                          <TableCell
                            className={classes.tableCellBilgi}
                            align="right"
                            sx={{ fontWeight: 600, color: '#1976d2' }}
                          >
                            {row.Z030
                              ? `${parseFloat(row.Z030).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TL`
                              : '0,00 TL'}
                          </TableCell>
                          <TableCell
                            className={classes.tableCellBilgi}
                            align="right"
                            sx={{ fontWeight: 600, color: '#1976d2' }}
                          >
                            {row.Z060
                              ? `${parseFloat(row.Z060).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TL`
                              : '0,00 TL'}
                          </TableCell>
                          <TableCell
                            className={classes.tableCellBilgi}
                            align="right"
                            sx={{ fontWeight: 600, color: '#1976d2' }}
                          >
                            {row.Z090
                              ? `${parseFloat(row.Z090).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TL`
                              : '0,00 TL'}
                          </TableCell>
                          <TableCell
                            className={classes.tableCellBilgi}
                            align="right"
                            sx={{ fontWeight: 600, color: '#1976d2' }}
                          >
                            {row.Z120
                              ? `${parseFloat(row.Z120).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TL`
                              : '0,00 TL'}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={7}
                          align="center"
                          className={classes.tableCellBilgi}
                          sx={{
                            py: 4,
                            color: '#9e9e9e',
                            fontStyle: 'italic'
                          }}
                        >
                          Veri bulunamadı
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, borderTop: '1px solid #f5f5f5' }}>
          <IconButton
            sx={{
              color: '#424242',
              borderRadius: '10px',
              '&:hover': {
                backgroundColor: 'rgba(66, 66, 66, 0.08)',
                transform: 'scale(1.05)'
              },
              transition: 'all 0.2s'
            }}
            onClick={() => setWholesalePricePopUp(false)}
            aria-label="close"
            component="span"
            variant="contained"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}

export default InvoiceRefund;
